import { store } from '../core/store'
import { translate } from '../i18n'
import { $ } from './dom'
import { getTurnstileToken } from '../core/turnstile'

// Same contract as the current site's /api/contact (name, email, message).
const ENDPOINT: string = import.meta.env.VITE_CONTACT_ENDPOINT || '/api/contact'
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function initContactForm(): void {
  const form = $<HTMLFormElement>('#contact-form')
  const status = $('#form-status')
  const button = $<HTMLButtonElement>('button[type="submit"]', form)
  const label = $('[data-i18n="contact.form.send"]', button)
  const t = (key: string) => translate(store.get().lang, key)

  const setStatus = (kind: 'ok' | 'error' | '', text: string) => {
    status.dataset.kind = kind
    status.textContent = text
  }

  form.addEventListener('submit', async (event) => {
    event.preventDefault()
    const data = new FormData(form)
    const payload = {
      name: String(data.get('name') ?? '').trim(),
      email: String(data.get('email') ?? '').trim(),
      message: String(data.get('message') ?? '').trim(),
    }
    if (String(data.get('company') ?? '')) return // honeypot tripped
    if (!payload.name || !payload.message || !EMAIL_RE.test(payload.email)) {
      setStatus('error', t('contact.form.invalid'))
      form.querySelector<HTMLElement>(':invalid')?.focus()
      return
    }

    button.disabled = true
    label.textContent = t('contact.form.sending')
    setStatus('', '')
    try {
      // Invisible Cloudflare Turnstile bot verification
      const turnstileToken = await getTurnstileToken()
      const requestPayload = { ...payload, turnstileToken }

      const response = await fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestPayload),
      })
      if (!response.ok) {
        const errJson = (await response.json().catch(() => ({}))) as { error?: string }
        throw new Error(errJson.error || `HTTP ${response.status}`)
      }
      const result = (await response.json().catch(() => ({}))) as { warning?: string }
      setStatus('ok', result.warning || t('contact.form.success'))
      form.reset()
    } catch {
      setStatus('error', `${t('contact.form.error')} → info@craft-tower.com`)
    } finally {
      button.disabled = false
      label.textContent = t('contact.form.send')
    }
  })
}
